import React, { Component } from "react";
import { Container } from "app/NativeComponents/common";
import { Header } from "app/NativeComponents/snippets";
import Logos from "./Logos";

import CopyContainer from "./CopyContainer";
import FormContainer from "./FormContainer";

class GetStartedWrapper extends Component {
  render() {
    return (
      <Container
        style={{
          height: this.props.window_height
        }}
      >
        <Header
          title=""
          titleColor="#fff"
          component={() => {
            return <Logos {...this.props} />;
          }}
          backgroundColor="#31cce5"
          rightButtonTitle={"Log in"}
          rightButtonColor="#fff"
          rightButtonAction={() =>
            this.props.appRedirect({ redirect: "login" })
          }
        />

        <div
          className="deal-start"
          style={{
            height: this.props.window_height - 60
          }}
        >
          <CopyContainer {...this.props} />
          <FormContainer {...this.props} />
        </div>
      </Container>
    );
  }
}

export default GetStartedWrapper;
